import { provide, inject, type InjectionKey } from 'vue'

export type ShibouDoukishoFormatData = {
  createDate: Date | null
  writeDate?: string
  longreason: string
  introSummary: string
  entrySummary: string
  resumeSummary: string
  occupation: string
  jobSummary: string
  experienceAndKnowledge: string
  skillsToUse: unknown[]
  jobHistories: unknown[]
  licenseHistories: unknown[]
  prMessage: string
  ai_education_detail: string
  ai_licenses_detail: string
  ai_job_detail: string
  ai_company_url: string
  ai_company_name: string
  ai_company_industry: string
  ai_company_job: string
  ai_company_values: string
  ai_future_vision: string
  ai_strength_episode: string
} & Record<string, unknown>

const SHIBOU_DOUKISHO_FORMAT_DATA_KEY: InjectionKey<ShibouDoukishoFormatData> =
  Symbol('shibouDoukishoFormatData')

export function provideShibouDoukishoFormatData(
  formatData: ShibouDoukishoFormatData
) {
  provide(SHIBOU_DOUKISHO_FORMAT_DATA_KEY, formatData)
}

export function useShibouDoukishoFormatData(): ShibouDoukishoFormatData {
  const formatData = inject(SHIBOU_DOUKISHO_FORMAT_DATA_KEY)
  if (!formatData) {
    throw new Error(
      'useShibouDoukishoFormatData() must be used under ShibouDoukishoEdit'
    )
  }
  return formatData
}

export function createEmptyShibouDoukishoFormatData(): ShibouDoukishoFormatData {
  return {
    createDate: null,
    longreason: '',
    introSummary: '',
    entrySummary: '',
    resumeSummary: '',
    occupation: 'others',
    jobSummary: '',
    experienceAndKnowledge: '',
    skillsToUse: [],
    jobHistories: [],
    licenseHistories: [],
    prMessage: '',
    ai_education_detail: '',
    ai_licenses_detail: '',
    ai_job_detail: '',
    ai_company_url: '',
    ai_company_name: '',
    ai_company_industry: '',
    ai_company_job: '',
    ai_company_values: '',
    ai_future_vision: '',
    ai_strength_episode: ''
  }
}
